import React from "react";

const DubbingAndVoiceoverMain = () => {
  return (
    <section className="min-h-screen pb-10 bg-white">

      {/* Main Content */}
      <div className="container max-w-6xl px-4 mx-auto mt-8">
        <div className="flex flex-col items-center gap-8 md:flex-row md:items-start">
          {/* Left: Course Image */}
          <div className="w-full md:w-1/2" data-aos="fade-right">
            <img src="https://sunrisingcinevisionacademy.com/public/assets/images/dubbing.jpg" alt="Dubbing & Voiceover" className="w-full h-auto rounded-lg shadow-lg" />
          </div>
          {/* Right: Course Intro */}
          <div className="w-full p-2 md:w-1/2" data-aos="fade-left">
            <h2 className="text-2xl font-bold mb-2 text-[#A14D1F]">Master the Art of Dubbing and Voice Acting with Sunrising Cinevision Academy</h2>
            <p className="mb-4 text-gray-700">
              Sunrising Cinevision Academy, one of the best film and music studios, offers a specialized <strong>dubbing artist course</strong> designed for aspiring voice actors. Whether you aim to work in dubbing films, animation, commercials, or documentaries, this program provides hands-on training in recording in studio environments, script interpretation, and voice modulation. Enroll in one of the top <strong>voice artist courses</strong> to master industry-standard voice-over techniques and build a strong portfolio.
            </p>
            <h2 className="text-xl font-bold mb-2 text-[#A14D1F]">What You Will Learn</h2>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li>Core principles of voice artistry and dubbing for films</li>
              <li>Voice modulation, pitch control, and character development</li>
              <li>Recording in studio environments using professional equipment</li>
              <li>Lip-syncing, timing, and adapting to different dubbing styles</li>
              <li>Script interpretation, emotion delivery, and industry-standard techniques</li>
            </ul>
          </div>
        </div>

        {/* Course Modules */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-right">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 1: Introduction to Dubbing and Voice-Over</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>History and evolution of dubbing films</li>
              <li>Types of dubbing and voice-over (animation, film, TV, commercials)</li>
              <li>Vocal warm-ups, breathing techniques, and articulation exercises</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 2: Script Interpretation and Analysis</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Understanding script structure and format</li>
              <li>Identifying key elements like tone, style, and dialogue delivery</li>
              <li>Techniques for conveying emotions effectively through voice</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-right">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 3: Voice Modulation and Character Development</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Understanding vocal range and modulation</li>
              <li>Developing unique character voices and accents</li>
              <li>Practicing voice-over techniques, including inflection and emphasis</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 4: Dubbing & Voice-Over Techniques</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Fundamentals of lip-syncing and timing in dubbing</li>
              <li>Adapting dubbing for different languages and cultures</li>
              <li>Voice-over for narration, commercials, documentaries, and audiobooks</li>
            </ol>
          </div>
        </div>

        {/* Instructors & More */}
        <div className="p-10 mt-10 bg-white shadow-md rounded-xl">
          <h2 className="text-3xl font-bold text-center mb-10 text-[#A14D1F]">Learn from Industry Experts</h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Faculty</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Experienced dubbing artists and voice-over professionals</li>
                <li>Industry professionals specializing in voice artistry</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Guest Lectures</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Renowned voice actors and dubbing professionals</li>
                <li>Experts from leading music studios and film production houses</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Practical Experience</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Hands-on recording in studio sessions with professional equipment</li>
                <li>Dubbing exercises for different film and animation projects</li>
                <li>Real-world projects, including voice-over work for short films and commercials</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Partnerships, Alumni, Certifications, Scholarships, Duration, Outcomes */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Industry Partnerships</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Indian Dubbing Artists Association (IDAA)</li>
              <li>International Voice Over Academy (IVOA)</li>
              <li>Major music studios and film production houses</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Alumni Network</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Connect with successful alumni in dubbing, voice-over, and audio production</li>
              <li>Participate in mentorship programs</li>
              <li>Access job placement opportunities</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Certifications Offered</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Certificate in Dubbing and Voice-Over Techniques</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Scholarship Opportunities</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Merit-based scholarships</li>
              <li>Need-based scholarships</li>
              <li>Talent-based scholarships</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Course Duration</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Certificate in Dubbing and Voice-Over Techniques – 12 Weeks</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Key Learning Outcomes</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Develop professional dubbing and voice-over skills for various media</li>
              <li>Master voice modulation, character creation, and studio recording</li>
              <li>Learn script interpretation, lip-syncing, and industry best practices</li>
              <li>Build a professional demo reel and portfolio</li>
              <li>Gain hands-on experience with expert mentorship and industry exposure</li>
            </ul>
          </div>
        </div>

        {/* Call to Action */}
        <div className="p-8 mt-10 text-center bg-white shadow-md rounded-xl" data-aos="fade-up">
          <h3 className="uppercase tracking-wide text-lg font-bold mb-4 text-[#A14D1F]">Take the Next Step in Your Voice Acting Career!</h3>
          <p className="mb-6 text-gray-700">Enroll in the dubbing and voice-over course at Sunrising Cinevision Academy and develop the skills to succeed in the competitive world of voice acting and dubbing.</p>
          <a href="/admission" className="inline-block px-8 py-3 text-lg font-bold text-white bg-gradient-to-r from-[#A14D1F] via-[#A14D1F] to-[#4A2F24] rounded-2xl shadow-lg hover:scale-105 transition-transform">Apply Now</a>
        </div>
      </div>
    </section>
  );
};

export default DubbingAndVoiceoverMain;
